// extracted by mini-css-extract-plugin
export default {"cls1":"PaperAbstract-cls1_OTh","cls2":"PaperAbstract-cls2_tor PaperAbstract-cls1_OTh","variant-dense":"PaperAbstract-variant-dense_xZp"};